import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as UIC from '@dds-uicore/all';
import { Notifications } from '../shared/models/notification';
import { CommonService } from '../shared/services/common.service';
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  notification:Notifications;
  notificationMap = new Map<string, string>([
    ["Success","dds__icons dds__task-check dds__icon-h4"],
    ["Error","dds__icons dds__alert-notice dds__icon-h4"],
    ["Information","dds__icons dds__alert-info-cir dds__icon-h4"],
  ]);
  notificationMapForId = new Map<string, string>([
    ["Success","#dds__task-check"],
    ["Error","#dds__alert-notice"],
    ["Information","#dds__alert-info-cir"],
  ]);
  processingLogin: boolean;
  constructor(private commonService:CommonService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      if (Object.keys(params).length) { //params like accessToken and expiresIn
        this.processingLogin=true;
      }
      else
        this.processingLogin=false;
    });

    [].forEach.call(document.querySelectorAll("[data-dismiss=\"dds__alert\"]"), function(element) {
      new UIC.Alert(element);
    });


    this.commonService.getNotificationUpdateListener().
     subscribe((notification:Notifications[])=>{
       this.notification=notification[0];
       setTimeout(() => {
        this.closeNotificaion();
      }, 5000);

    });


  }
  closeNotificaion() {
    document.getElementById('notification').classList.add('hidden');
    this.notification=null;
  }

}
